import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray2};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.neutral.white};

  img {
    width: 100%;
    height: 140px;
    object-fit: cover;
    border-radius: 6px;
  }

  span {
    font-size: 12px;
    word-break: break-word;
  }
`;

export const Status = styled.strong`
  font-size: 12px;
  color: ${({ theme, status }) => {
    if (status === "Aprovada") return theme.colors.primary.vividCerulean;
    if (status === "Reprovada") return "#AD4A33";

    return theme.colors.neutral.black;
  }};
`;

export const Buttons = styled.div`
  display: flex;
  gap: 8px;

  button {
    width: 100% !important;
  }
`;

// Item não-imagem do Álbum (B05, 03/09/2026): a mesma caixa da miniatura, com o
// tipo em texto e o link para abrir/baixar. Renderizar vídeo ou PDF com <img>
// mostraria só o ícone de imagem quebrada.
export const NonImage = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 120px;

  border: 1px dashed ${({ theme }) => theme.colors.neutral.cinza600};

  color: ${({ theme }) => theme.colors.primary.vividCerulean};
  font-size: 12px;
  text-decoration: underline;
`;
